export const APP_ROUTES = {
    LOGIN: "/login",
    REGISTRATION: "/registration",
    PRICE: "/price",
    DOCUMENTATION: "/documentation",
    SETTINGS: "/settings",
    WORKSPACE: "/workspace",
    ROUTES: "/routes",
    RECOVERY_PASSWORD: "/recovery-password",
    OFFER: "/offer",
    HELP: "/help",
    SERVICE: "/service",
    LOG: "/log",
    LOGS: "/logs",
    DASHBOARD: "/dashboard",
    CHANGE_PASSWORD: "/change_password",
    JSON_VALIDATOR: "/json-validator",
    TOOLS: "/tools",
    UUID_GENERATOR: "/tools/uuid-generator",
    BASE64: "/tools/base64",
    URL_ENCODER: "/tools/url-encoder",
    JWT_DEBUGGER: "/tools/jwt-debugger",
    CONNECT: "/connect",
};

export const API_ROUTES = {
    LOGIN: `${process.env.REACT_APP_API}/api/login`,
    REGISTRATION: `${process.env.REACT_APP_API}/api/registration`,
    WORKSPACE: `${process.env.REACT_APP_API}/api/workspace`,
    ROUTES: `${process.env.REACT_APP_API}/api/routes`,
    SETTINGS: `${process.env.REACT_APP_API}/api/setting`,
    LOG: `${process.env.REACT_APP_API}/api/log`,
    UPLOAD: `${process.env.REACT_APP_API}/api/upload`,
    INFO: `${process.env.REACT_APP_API}/api/info`,
    STATISTICS: `${process.env.REACT_APP_API}/api/statistics`,
    NPS: `${process.env.REACT_APP_API}/api/nps`,
    RECOVERY_PASSWORD: `${process.env.REACT_APP_API}/api/password-recovery`,
    SUPPORT: `${process.env.REACT_APP_API}/api/help`,
    LOGOUT: `${process.env.REACT_APP_API}/logout`,
    CHANGE_PASSWORD: `${process.env.REACT_APP_API}/api/change-password`,
    TOKENS: `${process.env.REACT_APP_API}/api/tokens`,
};
